module.exports = __webpack_public_path__ + "static/media/artDSR.b6ee2b22.png";